import SignaturesPart from './SignaturesPart';

export default SignaturesPart;
